import { NavLink } from 'react-router-dom';
import { LuArrowRight } from 'react-icons/lu';
import './style.css';

const getTypeClassName = (type) => {
  if (type.includes('BIM')) return 'projects__type projects__type--bim';
  if (type.includes('2D')) return 'projects__type projects__type--docs';
  return 'projects__type projects__type--mixed';
};

const ProjectItem = ({ projectId, project, type, useContainedMedia = false }) => {
  if (!project) return null;
  const { index, title, description, tags = [], image, ctaLabel } = project;
  return (
    <NavLink to={`/project/${projectId}`} className="projects__link">
      <article className="projects__item">
        <div className={`projects__media${useContainedMedia ? ' projects__media--contain' : ''}`}>
          <img
            src={image.preview}
            alt={image.alt}
            className={`projects__img${useContainedMedia ? ' projects__img--contain' : ''}`}
            loading="lazy"
          />

          <span className="projects__index">{index}</span>
          <div className="projects__meta">
            <span className={getTypeClassName(type.label)}>{type.label}</span>
          </div>
        </div>

        <div className="projects__content">
          <h3 className="projects__title">{title}</h3>
          <p className="projects__excerpt">{description}</p>

          <ul className="projects__tags">
            {tags.map((tag) => (
              <li key={tag} className="projects__tag">
                {tag}
              </li>
            ))}
          </ul>

          <div className="projects__cta">
            <span>{ctaLabel}</span>
            <LuArrowRight />
          </div>
        </div>
      </article>
    </NavLink>
  );
};

export default ProjectItem;
